<script setup lang="ts">
import { reformatDate } from '@/utils/date'
import type { Category } from '@/models/content'
import { TIME_FORMAT } from '@/constants/app'

const props = withDefaults(
  defineProps<{
    categories: Category[]
    publishedDate: string
    duration: number
    twitterLink?: string | null
    linkedInLink?: string | null
    author?: Record<string, unknown> | null
  }>(),
  {
    twitterLink: null,
    linkedInLink: null,
    author: null,
  },
)

const formattedDate = computed(() =>
  reformatDate(props.publishedDate, TIME_FORMAT, 'do MMMM yyyy'),
)

const formattedDuration = useFormattedDuration('article', props.duration)
</script>

<template>
  <div>
    <div class="mb-2 border-b-2 border-t-2 border-s-200 py-2 pb-5">
      <div class="flex justify-between">
        <p class="text-sm font-semibold">{{ formattedDate }}</p>
        <p class="mt-1 text-sm">{{ formattedDuration }}</p>
      </div>

      <div v-if="categories.length" class="mt-2 flex flex-wrap gap-2">
        <LinkedPill
          v-for="category in categories"
          :key="category.id"
          type="category"
          :slug="category.slug"
          variant="black"
        >
          {{ category.name }}
        </LinkedPill>
      </div>

      <!-- Author info -->
      <div
        v-if="author?.fullName"
        class="mt-[14px] text-sm font-bold text-s-600 lg:order-4 lg:px-0 lg:text-base"
      >
        <div>
          <p>By {{ author.fullName }}, {{ author.jobTitle }}</p>
          <p>{{ author.company }}</p>
        </div>
      </div>
    </div>

    <SocialLinks
      class="mt-4 gap-x-2"
      icon-classes="h-4 w-4 fill-s-900"
      hide-newsletter
      :twitter-link="twitterLink"
      :linked-in-link="linkedInLink"
    />
  </div>
</template>
